import React from 'react';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';

export const ACCENT = '#D44E20';
export const GREEN = '#3ECF8E';
export const BLUE = '#3B82F6';
export const PURPLE = '#8B5CF6';
export const AMBER = '#F59E0B';
export const TIER_COLORS = { Bronze: '#CD7F32', Silver: '#C0C0C0', Gold: '#FFD700', Platinum: '#E5E4E2' };
export const TYPE_LABELS = {
  purchase: { label: 'Acquisto', color: '#3ECF8E' }, manual_bonus: { label: 'Bonus', color: '#D44E20' },
  redeem: { label: 'Riscatto', color: '#EF4444' }, welcome: { label: 'Benvenuto', color: '#2196F3' },
  referral: { label: 'Referral', color: '#9C27B0' }, birthday: { label: 'Compleanno', color: '#E91E63' },
  expiry: { label: 'Scadenza', color: '#FF9800' },
};

export function Spinner() {
  return <div className="flex items-center justify-center h-64"><div className="w-8 h-8 border-2 border-[#D44E20] border-t-transparent rounded-full animate-spin" /></div>;
}

export function KpiCard({ label, value, sub, icon: Icon, color = '#1A1A1A', change, testid }) {
  return (
    <div className="bg-white rounded-2xl p-5 border border-slate-100 shadow-[0_2px_10px_rgba(0,0,0,0.04)] hover:shadow-[0_8px_30px_rgba(0,0,0,0.06)] transition-shadow duration-300 h-full" data-testid={testid}>
      <div className="flex items-center justify-between mb-2">
        <p className="text-[#64748B] text-xs font-medium">{label}</p>
        {Icon && <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${color}12` }}><Icon size={15} style={{ color }} /></div>}
      </div>
      <p className="text-2xl font-bold tabular-nums" style={{ color }}>{typeof value === 'number' ? value.toLocaleString('it-IT') : value}</p>
      <div className="flex items-center gap-2 mt-1">
        {change !== undefined && change !== null && (
          <span className={`text-xs font-medium flex items-center gap-0.5 ${change >= 0 ? 'text-[#3ECF8E]' : 'text-[#EF4444]'}`}>
            {change >= 0 ? <ArrowUpRight size={12} /> : <ArrowDownRight size={12} />}
            {change >= 0 ? '+' : ''}{change}%
          </span>
        )}
        {sub && <p className="text-[#64748B] text-[10px]">{sub}</p>}
      </div>
    </div>
  );
}
